import BulkUploadModal from './BulkUploadModal';

export default BulkUploadModal;
